var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 10H18C13.58 10 10 13.58 10 18V74C10 78.42 13.58 82 18 82H74C78.42 82 82 78.42 82 74V18C82 13.58 78.42 10 74 10ZM34 66H23.908V38H34V66ZM28.776 32.868C25.692 32.868 23.632 30.812 23.632 28.068C23.632 25.324 25.688 23.268 29.116 23.268C32.2 23.268 34.26 25.324 34.26 28.068C34.26 30.812 32.204 32.868 28.776 32.868ZM70 66H60.232V50.696C60.232 46.464 57.628 45.488 56.652 45.488C55.676 45.488 52.42 46.14 52.42 50.696C52.42 51.348 52.42 66 52.42 66H42.328V38H52.42V41.908C53.72 39.628 56.324 38 61.208 38C66.092 38 70 41.908 70 50.696V66Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a19f99810fda67f6780a8af8a325e235.svg";
export { ForwardRef as ReactComponent };